/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  IRetentionDataItem,
  // eslint-disable-next-line no-unused-vars
  IRetentionParams,
} from '@dashboardWirelineRetentionDepartment/RetentionManagerDepartment.models';
import getRenewedEngagements from '@dashboardWirelineRetentionDepartment/GetRenewedEngagements/api.service';

export interface IState {
  data: IRetentionDataItem;
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: {},
  isLoading: false,
  error: null,
};

export const getRenewedEngagementsAction = createAsyncThunk(
  'getRenewedEngagementsAction',
  async ({ controller, params }: { controller: AbortController, params: IRetentionParams },
    { rejectWithValue }) => {
    try {
      const { signal } = controller;
      const { data } = await getRenewedEngagements(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const RenewedEngagementsSlice = createSlice({
  name: 'getRenewedEngagements',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRenewedEngagementsAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRenewedEngagementsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getRenewedEngagementsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = {};
      });
  },
});

export const getRenewedEngagementsReducer = RenewedEngagementsSlice.reducer;
